import { Pipe } from "@angular/core";

@Pipe({ name: "simnao" })
export class SimNaoPipe {
    transform(valor: any): any {
        if (!valor) {
            return "Não";
        }
        return "Sim";
    }
}
